// extracted by mini-css-extract-plugin
export default {"drop-container":"DropInput_drop-container__PPCq5","default-cursor":"DropInput_default-cursor__eRibm","drop-img":"DropInput_drop-img__yUnGC"};